var exports = {
  "k": "x112a1f60--819aff--container",
  "I": "x112a1f60--819aff--logo_img",
};

module.exports = exports;
